import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { toggleCheckedItem, toggleEditModal, setPage, to, setSortListEndpoint } from '../../store/statsTabSlice';


import store from '../../store/store.js';
import {useState} from "react";


export const fetch = async ( dispatch, setData, setUserData, setTrainingsData) => {
  const response = await ApiService.getStatistics();
  console.log('Odpowiedź z API:', response);
  // Pobierz dane statystyczne podczas ładowania komponentu

      if (response) {
        setData({
          usersStats: {
            registered: response.usersTotalAccounts || '0',
            unconfirmed: response.usersUnconfirmedAccounts || '0',
            active: response.usersActiveAccounts || '0',
            blocked: response.usersHasBlocked || '0',
          },
          trainingsStats: {
            proposed: response.trainingsTotal || '0',
            completed: response.trainingsCompleted || '0',
          },
          plansStats: {
            basic: response.subscriptionsBasic || '0',
            premium: response.subscriptionsPremium || '0',
          }
        });
        setUserData({
          usersStats: {
            female: response.sexF || '0',
            male: response.sexM || '0',
            others: response.sexU || '0',
          },
          ageStats: {
            _16_18: response.age1618 || '0',
            _19_25: response.age1925 || '0',
            _26_35: response.age2635 || '0',
            _36_45: response.age3645 || '0',
            _46: response.age46AndMore || '0',
          },
        });

        setTrainingsData({
          trainingsStats: {
            proposed: response.trainingsTotal || 0,
            training_rejected: response.trainingsCanceled|| 0,
            invitation_rejected: response.trainingsRejected|| 0,
            ended: response.trainingsCompleted || 0,
          },
          sports: response.sportGroupedTrainingsStats || {},
          rates: response.sportGroupedTrainingsAvgScoreStats || {},
          avg_rate: response.avgStats || 0.0
        });
      }
    };
